import i18n from "@/app/plugins/i18n";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const readableText = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;
  const text = value.trim();
  return text && text !== "[object Object]" ? value : undefined;
};

const bodyMessage = (value: unknown): string | undefined => {
  if (isRecord(value)) {
    return readableText(value.message) ?? readableText(value.error);
  }
  return readableText(value);
};

export const getErrorMessage = (error: unknown, fallback?: string): string => {
  const record = isRecord(error) ? error : undefined;
  const response = isRecord(record?.response) ? record.response : undefined;

  return (
    bodyMessage(response?.data) ??
    bodyMessage(record?.data) ??
    bodyMessage(error) ??
    readableText(fallback) ??
    i18n.global.t("errors.defaultError")
  );
};
